import * as React from "react";

interface ExcelConsolePanelProps {
  logs: string[];
  isOpen: boolean;
  onToggle: () => void;
}

export const ExcelConsolePanel: React.FC<ExcelConsolePanelProps> = ({ logs, isOpen, onToggle }) => {
  return (
    <div className="mt-3 border-t border-border pt-2">
      <div
        className="flex items-center justify-between cursor-pointer py-1.5 px-2 rounded-md hover:bg-accent"
        onClick={onToggle}
      >
        <span className="text-[11px] text-muted-foreground font-medium">
          {isOpen ? "▼" : "▶"} Console ({logs.length})
        </span>
      </div>
      {isOpen && logs.length > 0 && (
        <div className="font-mono text-[10px] text-muted-foreground whitespace-pre-wrap break-words max-h-[150px] overflow-y-auto bg-primary/5 p-2 rounded-md border border-border mt-1.5">
          {logs.join("\n")}
        </div>
      )}
    </div>
  );
};
